/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AsyncDataOptions } from '#app'
import { HttpError } from '~/utils/http-errors'

export async function $apiFetch<T>(
  key: string,
  request: Parameters<typeof $fetch<T>>[0],
  opts?: Parameters<typeof $fetch<T>>[1],
  asyncDataOpts?: Parameters<typeof useAsyncData>[2],
  isFetchOnly: boolean = true,
) {
  const { token, status } = useAuth()
  // workaround for tracing
  // https://github.com/unjs/ofetch/issues/339
  const { $instrumentedFetch } = useNuxtApp()

  if (!isFetchOnly) {
    const { data, error } = await useAsyncData<T>(key, () => ($instrumentedFetch as typeof $fetch)<T>(request, {
      ...opts,
      headers: {
        'Authorization': status.value == 'authenticated' ? token.value! : '',
        'Content-Type': 'application/json',
        ...opts?.headers,
      },
    }), asyncDataOpts as AsyncDataOptions<T>)
    if (error.value) throw new HttpError(error.value.statusCode, error.value.message, error.value.data)
    return { data: data }!
  }
  try {
    const data = await ($instrumentedFetch as typeof $fetch)<T>(request, {
      ...opts,
      headers: {
        'Authorization': status.value == 'authenticated' ? token.value! : '',
        'Content-Type': 'application/json',
        ...opts?.headers,
      },
    })
    return { data: ref(data) } as { data: Ref<T> }
  }
  catch (error) {
    // toast error here based on some logic.
    throw new HttpError((error as any).statusCode, (error as any).message, (error as any).data)
  }
}

export function $apiLazyFetch<T>(
  key: string,
  request: Parameters<typeof $fetch<T>>[0],
  opts?: Parameters<typeof $fetch<T>>[1],
  asyncDataOpts: Parameters<typeof useAsyncData>[2] = { lazy: true, server: false },
) {
  return $apiFetch<T>(key, request, opts, asyncDataOpts)
}
